interface TranslationResponse {
    alternatives: string[];
    translatedText: string;
}

function maskString(s: string): [string, any[]] {
  const placeholders: any[] = [];
  const maskedText = s.replace(/\{[^}]+\}/g, (match) => {
    const index = placeholders.length
    const token = `\${${index}}`;
    placeholders.push({ token, value: match });
    return token;
  });
  return [maskedText, placeholders]
}

function fixString(s: string, placeholders: any[]) {
    let finalText = s;
    placeholders.forEach(({ token, value }) => {
        finalText = finalText.replace(token, value);
    });
    return finalText;
}

function fixResult(res: TranslationResponse, placeholders: any[]) {
    return {
        translatedText: fixString(res.translatedText, placeholders),
        alternatives: res.alternatives.map(it => fixString(it, placeholders))
    }
}

export async function fetchLibreTranslate(_s: string, fromLang: string, toLang: string) {
    const [s, placeholders] = maskString(_s)
    const response = await fetch("https://libretranslate.be-efficient-warehouse-suite.nl/translate", {
        method: "POST",
        body: JSON.stringify({
            q: s,
            source: fromLang,
            target: toLang,
            format: "text",
            alternatives: 3,
        }),
        headers: { 
            "Content-Type": "application/json"
        }
    });

    const result = await response.json()

    return fixResult(
        result as TranslationResponse, 
        placeholders
    )
}